export default __webpack_public_path__ + "static/media/cancel.30c1cc63.svg";